import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { fetchCAOfficeLocations } from "./request";

export function useCAOfficeLocationsQuery(
  options?: Omit<UseQueryOptions<string[], Error>, "queryKey" | "queryFn">,
) {
  return useQuery({
    queryKey: ["meeting", "ca-office-locations"],
    queryFn: fetchCAOfficeLocations,
    staleTime: 1000 * 60 * 60,
    ...options,
  });
}
